import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Link, SidebarModal } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useSubscriber from '@hooks/useSubscriber'

import type { SubscriberModel } from '@models/types'

interface SubscriberProps {
  filteredSubscribersCount: number,
  initSubscriber: SubscriberModel,
}

const Subscriber = (props: SubscriberProps) => {
  const { filteredSubscribersCount, initSubscriber } = props

  const subscriberPayload = useSubscriber(initSubscriber)

  const {
    callbacks: { deleteSubscriber: deleteFn },
    image,
    user,
  } = subscriberPayload

  // @ts-expect-error TS2339
  const { full_name, mobile_number } = user

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This will remove the Subscriber from this Conversation.',
      deleteString: 'Remove',
      entityName: 'Subscriber',
    },
  }

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image.square_url}
      subtitle={mobile_number}
      title={full_name}
    >
      {filteredSubscribersCount > 1 && (
        <Link
          greyLink
          // @ts-expect-error TS2322
          marginLeft="auto"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          width="auto"
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </Link>
      )}
    </SidebarModal.User>
  )
}

export default Subscriber
